module.exports = __webpack_public_path__ + "img/+10_.39a0cd8b.svg";